import cx from 'classnames';
import Image from 'next/image';

import {Text} from '#component/base';
import {Transition} from '#component/util';
import {sprinkles} from '#style/sprinkles';

import {IntroStepProps} from './IntroStep.types';

import * as css from './IntroStep.css';

export const IntroStep = ({
  className,
  headline,
  lede,
  imgSrcSet = [],
  ...otherProps
}: IntroStepProps) => (
  <Transition className={cx(css.transition, className)} {...otherProps}>
    <Transition.Child
      className={css.root}
      enterFrom={css.enterFrom}
      enterTo={css.enterTo}
      leaveFrom={css.leaveFrom}
      leaveTo={css.leaveTo}>
      <div className={css.body}>
        <Text as="h1" color="cotton" variant="heading2">
          {headline}
        </Text>

        <Text as="p" color="cotton" className={sprinkles({opacity: 0.7})}>
          {lede}
        </Text>

        <div className={css.mobileImage}>
          <Image alt="" layout="fill" src={imgSrcSet[0]} />
        </div>

        <div className={css.tabletImage}>
          <Image alt="" layout="fill" src={imgSrcSet[imgSrcSet.length - 1]} />
        </div>
      </div>

      <div className={css.desktopImage}>
        <Image alt="" layout="fill" src={imgSrcSet[imgSrcSet.length - 1]} />
      </div>
    </Transition.Child>
  </Transition>
);
